/**
 * Custom shaders for unit rendering with faction color support
 */

// Custom shader for faction color blending
export const factionVertexShader = `
  attribute vec3 color;
  varying vec3 vColor;
  varying vec3 vNormal;
  varying vec3 vViewPosition;

  void main() {
    vColor = color;
    vNormal = normalize(normalMatrix * normal);
    vec4 mvPosition = modelViewMatrix * instanceMatrix * vec4(position, 1.0);
    vViewPosition = -mvPosition.xyz;
    gl_Position = projectionMatrix * mvPosition;
  }
`;

export const factionFragmentShader = `
  uniform vec3 primaryColor;
  uniform vec3 secondaryColor;
  uniform vec3 ambientLightColor;
  uniform vec3 directionalLightColor;
  uniform vec3 directionalLightDirection;

  varying vec3 vColor;
  varying vec3 vNormal;
  varying vec3 vViewPosition;

  void main() {
    vec3 finalColor = vColor;

    // Check if this is a faction color marker
    // Primary: R > 0.9, G < 0.2, B < 0.2
    // Secondary: G > 0.9, R < 0.2, B < 0.2
    if (vColor.r > 0.9 && vColor.g < 0.2 && vColor.b < 0.2) {
      finalColor = primaryColor;
    } else if (vColor.g > 0.9 && vColor.r < 0.2 && vColor.b < 0.2) {
      finalColor = secondaryColor;
    }

    // Simple lighting
    vec3 normal = normalize(vNormal);
    vec3 lightDir = normalize(directionalLightDirection);
    float diff = max(dot(normal, lightDir), 0.0);

    vec3 ambient = ambientLightColor * 0.4;
    vec3 diffuse = directionalLightColor * diff * 0.6;

    vec3 litColor = finalColor * (ambient + diffuse);

    gl_FragColor = vec4(litColor, 1.0);
  }
`;
